(() => {
  const root = document.documentElement;
  const announcement = document.querySelector('.section-announcement-bar');
  const header = document.querySelector('.section-header');
  const countdown = document.getElementById('GlobalCountdown');

  if (!header) return;

  const DESKTOP_MIN_PX = 768;
  const TOP_REVEAL_PX = 8;
  const DOWN_INTENT_PX = 12;
  const UP_INTENT_PX = 4;
  const DELTA_TOLERANCE_PX = 2;
  const DETACH_SETTLE_MS = 500;
  const keepsHeaderVisible = document.body.classList.contains('template-suffix-measurement-new')
    || document.body.classList.contains('template-suffix-drapery-measurement-new');
  let lastY = Math.max(0, window.scrollY);
  let direction = 0;
  let directionTravel = 0;
  let frameRequested = false;
  let ignoreReverseUntil = 0;
  let lastViewportWidth = window.innerWidth;
  let headerHeight = Math.ceil(header.getBoundingClientRect().height);

  const isDesktop = () => window.innerWidth >= DESKTOP_MIN_PX;

  const measure = () => {
    headerHeight = Math.ceil(header.getBoundingClientRect().height);
    root.style.setProperty('--cz-header-full-height', `${headerHeight}px`);
  };

  const cartDrawerIsOpen = () => Boolean(
    document.querySelector('cart-drawer[open], cart-drawer[aria-hidden="false"]')
  );

  const hasInteractionLock = () => {
    const activeElement = document.activeElement;
    const headerHasFocus = activeElement && header.contains(activeElement);

    return Boolean(
      window.Shopify?.designMode ||
      headerHasFocus ||
      document.body.classList.contains('show-search') ||
      document.body.classList.contains('reveal-mobile-nav') ||
      header.classList.contains('section-header--nav-open') ||
      header.classList.contains('section-header--nav-hover') ||
      header.querySelector('[aria-expanded="true"]') ||
      cartDrawerIsOpen()
    );
  };

  const setHidden = (hidden) => {
    if (keepsHeaderVisible) {
      root.classList.remove('cz-header-detached', 'cz-header-hidden');
      root.dataset.czHeaderScrollState = isDesktop() ? 'visible-stable' : 'mobile-fixed';
      root.style.setProperty('--theme-sticky-header-height', `${headerHeight}px`);
      return;
    }
    const shouldHide = Boolean(
      hidden &&
      isDesktop() &&
      window.scrollY > TOP_REVEAL_PX &&
      !hasInteractionLock()
    );
    if (shouldHide) {
      if (!root.classList.contains('cz-header-detached')) {
        ignoreReverseUntil = Date.now() + DETACH_SETTLE_MS;
      }
      root.classList.add('cz-header-detached');
    } else if (!isDesktop() || window.scrollY <= TOP_REVEAL_PX) {
      root.classList.remove('cz-header-detached');
    }
    root.classList.toggle('cz-header-hidden', shouldHide);
    root.dataset.czHeaderScrollState = isDesktop()
      ? (shouldHide ? 'hidden' : 'visible')
      : 'mobile-fixed';
    root.style.setProperty(
      '--theme-sticky-header-height',
      shouldHide ? '0px' : `${headerHeight}px`
    );
  };

  const revealForInteraction = () => {
    direction = 0;
    directionTravel = 0;
    setHidden(false);
  };

  const updateFromScroll = () => {
    frameRequested = false;
    const currentY = Math.max(0, window.scrollY);

    if (!isDesktop() || currentY <= TOP_REVEAL_PX || hasInteractionLock()) {
      revealForInteraction();
      lastY = currentY;
      return;
    }

    const delta = currentY - lastY;
    lastY = currentY;
    if (Math.abs(delta) <= DELTA_TOLERANCE_PX) return;

    const nextDirection = delta > 0 ? 1 : -1;
    if (
      nextDirection < 0 &&
      root.classList.contains('cz-header-hidden') &&
      Date.now() < ignoreReverseUntil
    ) {
      direction = 0;
      directionTravel = 0;
      return;
    }
    if (direction !== nextDirection) {
      direction = nextDirection;
      directionTravel = 0;
    }
    directionTravel += Math.abs(delta);

    if (direction > 0 && directionTravel >= DOWN_INTENT_PX) {
      setHidden(true);
      directionTravel = 0;
    } else if (direction < 0 && directionTravel >= UP_INTENT_PX) {
      setHidden(false);
      directionTravel = 0;
    }
  };

  const requestScrollUpdate = () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(updateFromScroll);
  };

  const syncLayout = () => {
    measure();
    if (!isDesktop()) {
      revealForInteraction();
    } else if (hasInteractionLock()) {
      if (
        root.classList.contains('cz-header-hidden') &&
        Date.now() < ignoreReverseUntil
      ) return;
      revealForInteraction();
    } else {
      setHidden(root.classList.contains('cz-header-hidden'));
    }
  };

  const interactionObserver = new MutationObserver(syncLayout);
  interactionObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });
  interactionObserver.observe(header, {
    attributes: true,
    attributeFilter: ['class']
  });
  header.querySelectorAll('[aria-expanded]').forEach((control) => {
    interactionObserver.observe(control, {
      attributes: true,
      attributeFilter: ['aria-expanded']
    });
  });
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    interactionObserver.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['open', 'aria-hidden']
    });
  }

  const resizeObserver = new ResizeObserver(syncLayout);
  [announcement, header, countdown].filter(Boolean).forEach((element) => resizeObserver.observe(element));

  window.addEventListener('scroll', requestScrollUpdate, { passive: true });
  window.addEventListener('resize', () => {
    const widthChanged = window.innerWidth !== lastViewportWidth;
    lastViewportWidth = window.innerWidth;
    lastY = Math.max(0, window.scrollY);
    if (widthChanged) revealForInteraction();
    syncLayout();
  }, { passive: true });
  window.addEventListener('pageshow', () => {
    lastY = Math.max(0, window.scrollY);
    revealForInteraction();
    syncLayout();
  });
  document.addEventListener('focusin', revealForInteraction);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) revealForInteraction();
  });

  measure();
  root.classList.add('cz-header-scroll-ready');
  setHidden(false);
})();
